import AlterarSenha from './AlterarSenha';
import Lista from './Lista';

export const UsuarioLista = Lista;
export const UsuarioAlterarSenha = AlterarSenha;
